import { ProjectStakeholderDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectStakeholder = createAction(
  '[ProjectStakeholder] Load ProjectStakeholder'
);

export const loadProjectStakeholderSuccess = createAction(
  '[ProjectStakeholder] Load ProjectStakeholder Success',
  props<{ projectStakeholder: ProjectStakeholderDto[] }>()
);

export const loadProjectStakeholderFailure = createAction(
  '[ProjectStakeholder] Load ProjectStakeholder Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProjectStakeholder = createAction(
  '[ProjectStakeholder] Add ProjectStakeholder',
  props<{ newProjectStakeholder: ProjectStakeholderDto[] }>()
);

export const addProjectStakeholderSuccess = createAction(
  '[ProjectStakeholder] Add ProjectStakeholder Success',
  props<{ newProjectStakeholder: ProjectStakeholderDto[] }>()
);

export const addProjectStakeholderFailure = createAction(
  '[ProjectStakeholder] Add ProjectStakeholder Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProjectStakeholderRecord = createAction(
  '[ProjectStakeholder] Search  ProjectStakeholder Record',
  props<{ query: string }>()
);

/**
 * Update ProjectStakeholder Collection Actions
 */
export const updateProjectStakeholder = createAction(
  '[ProjectStakeholder] Update ProjectStakeholder',
  props<{ updateProjectStakeholder: ProjectStakeholderDto[] }>()
);

export const updateProjectStakeholderSuccess = createAction(
  '[ProjectStakeholder] Update ProjectStakeholder Success',
  props<{ updateProjectStakeholder: ProjectStakeholderDto[] }>()
);

export const updateProjectStakeholderFailure = createAction(
  '[ProjectStakeholder] Update ProjectStakeholder Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectStakeholder Collection Actions
 */
export const removeProjectStakeholder = createAction(
  '[ProjectStakeholder] Remove ProjectStakeholder',
  props<{ ids: string[] }>()
);

export const removeProjectStakeholderSuccess = createAction(
  '[ProjectStakeholder] Remove ProjectStakeholder Success',
  props<{ ids: string[] }>()
);

export const removeProjectStakeholderFailure = createAction(
  '[ProjectStakeholder] Remove ProjectStakeholder Failure',
  props<{ error: any }>()
);
